import React, { useState, useEffect, useCallback, useRef } from "react";

import { ITableAppRender } from "../../components/TableApp";
import TemplateTable from "../../components/TemplateTable";

import CadastrarCategoria from "./CadastrarCategoria";

import { ICategoria, ISearchResponse } from "../../interfaces";
import { Label } from "semantic-ui-react";
import { toast } from "react-toastify";
import CategoriaRepository from "../../Repositories/CategoriaRepository";
import errors from "../../Utils/ExtractErrors";
import { ISearch } from "../../components/Search";
import { IFields } from "../../components/Search/FilterBuilder";

const Categories: React.FC = () => {

    const [list, setList] = useState<ICategoria[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const setStatus = (status: number) => {
        if (status)
            return <Label ribbon icon="check" color="pink" content="ATI" />
        else
            return <Label ribbon icon="times" color="grey" content="INA" />
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Status",
            content: (x: ICategoria) => setStatus(x.status),
            textAlign: "left",
            width: 1
        },
        {
            header: "Nome",
            content: (x: ICategoria) => x.nome,
            width: 12
        },
    ];

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const load = useCallback(async () => {
        setLoading(true);
        try {

            let response: ISearchResponse<ICategoria>;

            if (refSearch.current.type === "simples") {
                response = await CategoriaRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await CategoriaRepository.List({
                    filter: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }, []);

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;

        load();
    }

    useEffect(() => { load() }, [load]);

    const fields: IFields[] = [
        { label: "Nome", name: "Nome", type: "string", roles: ["Admin", "Operador"] },
        {
            label: "Status",
            name: "Status",
            type: "enum",
            values: [
                { key: "INA", text: "INA", value: 0, label: { icon: "times", color: "grey", content: "INA" } },
                { key: "ATI", text: "ATI", value: 1, label: { icon: "check", color: "pink", content: "ATI" } },
            ],
            roles: ["Admin", "Operador"]
        }
    ];

    return (
        <TemplateTable
            title="Categorias"
            icon="tags"
            insert={<CadastrarCategoria onSuccess={load} />}
            tableList={list}
            tableRender={tableRender}
            searchPlaceHolder="Nome"
            onSearch={onSearch}
            filterFields={fields}
            tableLoading={loading}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
            tableOnChangeRecords={onChangeRecords}
        />
    );
};

export default Categories;
